"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _Today = _interopRequireDefault(require("@material-ui/icons/Today"));

var _ArrowForwardIos = _interopRequireDefault(require("@material-ui/icons/ArrowForwardIos"));

var _ArrowBackIos = _interopRequireDefault(require("@material-ui/icons/ArrowBackIos"));

var _Headings = require("../Headings");

var _Paragraph = require("../Paragraph");

var _Input = _interopRequireDefault(require("../Input"));

var _colours = _interopRequireDefault(require("../../constants/colours"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _dateFns = require("date-fns");

var _uuid = _interopRequireDefault(require("../../utils/uuid"));

var _Button = _interopRequireDefault(require("../Buttons/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// @todo - split calendar state, logic and styles out into separate component.
// @todo - Doesnt update internal Date when changed externally, just updates the input value
const PickerWrapper = _styledComponents.default.div`
	position: relative;
	width: 190px;
	cursor: pointer;
`;
const StyledCalendarIcon = (0, _styledComponents.default)(_Today.default)`
	position: absolute;
	right: 0;
	top: 50%;
	height: 100% !important;
	padding: 0 12px;
	border-left: 1px solid ${_colours.default.inputBorderColor};
	transform: translateY(-50%);
	color: ${_colours.default.primary};
`;
const CalendarHeader = _styledComponents.default.div`
	display: flex;
	margin-bottom: 14px;
	justify-content: space-between;
	align-items: center;
	text-align: center;
`;
const CalendarHeaderButton = (0, _styledComponents.default)(_Button.default)`
	max-width: min-content !important;
`;
const CalendarHeading = (0, _styledComponents.default)(_Paragraph.P)`
	margin-bottom: 18px;
	border-bottom: 1px solid ${_colours.default.activeFilter};
	text-align: center;
	padding: 11px 0;
	color: ${_colours.default.inactiveState};
`;
const CalendarBody = (0, _styledComponents.default)(_core.Paper)`
	width: 300px;
	padding: 30px;
	box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16) !important;
	cursor: default;
`;
const CalendarInner = _styledComponents.default.div`
	display: flex;
	margin-bottom: 20px;
`;
const CalendarColumn = _styledComponents.default.div`
	display: flex;
	flex: 1;
	flex-direction: column;
`;
const CalendarButton = (0, _styledComponents.default)(_Button.default)`
	display: block !important;
	width: 85% !important;
	margin: 0 auto !important;
	padding: 8px !important;
	min-width: unset !important;
	font-weight: bold !important;

	${({
  selected
}) => selected && `
			color: ${_colours.default.white} !important;
			background-color: ${_colours.default.blue} !important;
		`}
`;
const CalendarFooter = _styledComponents.default.div`
	display: flex;
	justify-content: flex-end;
`;
const CalendarFooterButton = (0, _styledComponents.default)(_Button.default)`
	color: ${_colours.default.blue} !important;
	font-size: 16px;
	font-weight: bold;
`;
const StyledInput = (0, _styledComponents.default)(({
  isOpen,
  ...props
}) => /*#__PURE__*/_react.default.createElement(_Input.default, props))`
	&.MuiInputBase-root input {
		box-shadow: ${({
  isOpen
}) => isOpen ? `${(0, _core.fade)(_colours.default.inputFocus, 0.25)} 0 0 0 0.2rem` : 'none'};
		border-color: ${({
  isOpen
}) => isOpen ? _colours.default.inputFocus : _colours.default.inputBorderColor};
	}
`;
const timeStartOfDay = {
  hours: 0,
  minutes: 0,
  seconds: 0,
  milliseconds: 0
};
const timeEndOfDay = {
  hours: 23,
  minutes: 59,
  seconds: 59,
  milliseconds: 999
};

const isDateBefore = (day, disablePast) => (0, _dateFns.isBefore)(day, (0, _dateFns.set)(disablePast, timeStartOfDay));

const isDateAfter = (day, disableFuture) => (0, _dateFns.isAfter)(day, (0, _dateFns.set)(disableFuture, timeEndOfDay));

const DatePickerV2 = ({
  value,
  label,
  required,
  error,
  onChange,
  disablePast,
  disableFuture,
  placeholder = 'DD/MM/YYYY',
  ...rest
}) => {
  const [anchorEl, setAnchorEl] = (0, _react.useState)(null);
  const [calendarOpen, toggleCalendarOpen] = (0, _react.useState)(false);
  const [calendarMonthYear, setCalendarMonthYear] = (0, _react.useState)(new Date());
  const [calendarDaysOrganised, setCalendarDaysOrganised] = (0, _react.useState)({});

  const handleClick = event => {
    toggleCalendarOpen(true);
    setAnchorEl(event.currentTarget);
  };

  const updateCalendar = direction => {
    setCalendarMonthYear(direction === 'prev' ? (0, _dateFns.sub)(calendarMonthYear, {
      months: 1
    }) : (0, _dateFns.add)(calendarMonthYear, {
      months: 1
    }));
  };

  (0, _react.useEffect)(() => {
    const organisedDays = {
      Mo: [],
      Tu: [],
      We: [],
      Th: [],
      Fr: [],
      Sa: [],
      Su: []
    };
    (0, _dateFns.eachDayOfInterval)({
      start: (0, _dateFns.sub)((0, _dateFns.startOfMonth)(calendarMonthYear), {
        days: (0, _dateFns.startOfMonth)(calendarMonthYear).getDay() === 0 ? 6 : (0, _dateFns.startOfMonth)(calendarMonthYear).getDay() - 1
      }),
      end: (0, _dateFns.endOfMonth)(calendarMonthYear.getDay()) !== 0 ? (0, _dateFns.add)((0, _dateFns.endOfMonth)(calendarMonthYear), {
        days: 7 - (0, _dateFns.endOfMonth)(calendarMonthYear).getDay()
      }) : (0, _dateFns.endOfMonth)(calendarMonthYear)
    }).forEach(day => organisedDays[(0, _dateFns.format)(day, 'EEEEEE')].push(day));
    setCalendarDaysOrganised(organisedDays);
  }, [calendarMonthYear]);

  const isDateDisabled = day => {
    let isDisabled = false;

    if (!(0, _dateFns.isSameMonth)(day, calendarMonthYear)) {
      isDisabled = true;
    }

    if (disablePast && isDateBefore(day, disablePast)) {
      isDisabled = true;
    } else if (disableFuture && isDateAfter(day, disableFuture)) {
      isDisabled = true;
    }

    return isDisabled;
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, label && /*#__PURE__*/_react.default.createElement(_core.InputLabel, {
    required: required,
    error: error
  }, label), /*#__PURE__*/_react.default.createElement(PickerWrapper, {
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement(StyledInput, _extends({
    value: value ? (0, _dateFns.format)(value, 'dd/MM/yyyy') : '',
    placeholder: placeholder,
    onKeyDown: handleClick,
    isOpen: calendarOpen
  }, rest)), /*#__PURE__*/_react.default.createElement(StyledCalendarIcon, null), /*#__PURE__*/_react.default.createElement(_core.Popper, {
    disablePortal: true,
    open: calendarOpen,
    anchorEl: anchorEl,
    placement: "bottom-start"
  }, calendarOpen && /*#__PURE__*/_react.default.createElement(_core.ClickAwayListener, {
    onClickAway: () => toggleCalendarOpen(false)
  }, /*#__PURE__*/_react.default.createElement(CalendarBody, null, /*#__PURE__*/_react.default.createElement(CalendarHeader, null, /*#__PURE__*/_react.default.createElement(CalendarHeaderButton, {
    onClick: () => updateCalendar('prev')
  }, /*#__PURE__*/_react.default.createElement(_ArrowBackIos.default, null)), /*#__PURE__*/_react.default.createElement(_Headings.Subtitle1, null, (0, _dateFns.format)(calendarMonthYear, 'MMMM yyyy')), /*#__PURE__*/_react.default.createElement(CalendarHeaderButton, {
    onClick: () => updateCalendar('next')
  }, /*#__PURE__*/_react.default.createElement(_ArrowForwardIos.default, null))), /*#__PURE__*/_react.default.createElement(CalendarInner, null, Object.keys(calendarDaysOrganised).map(key => /*#__PURE__*/_react.default.createElement(CalendarColumn, {
    key: (0, _uuid.default)()
  }, /*#__PURE__*/_react.default.createElement(CalendarHeading, null, key), calendarDaysOrganised[key].map(day => /*#__PURE__*/_react.default.createElement(CalendarButton, {
    key: day,
    onClick: () => onChange(day),
    disabled: isDateDisabled(day),
    selected: value && (0, _dateFns.isEqual)(day, (0, _dateFns.set)(value, {
      hours: 0,
      minutes: 0,
      seconds: 0,
      milliseconds: 0
    }))
  }, (0, _dateFns.format)(day, 'd')))))), !isDateDisabled(new Date()) && /*#__PURE__*/_react.default.createElement(CalendarFooter, null, /*#__PURE__*/_react.default.createElement(CalendarFooterButton, {
    onClick: () => {
      onChange((0, _dateFns.set)(new Date(), timeStartOfDay));
      setCalendarMonthYear(new Date());
    }
  }, "Today")))))));
};

var _default = DatePickerV2;
exports.default = _default;